import { createSlice } from "@reduxjs/toolkit";

export const emisoresSlices = createSlice({
  name: "emisores",
  initialState: {
    value: false,
  },
  reducers: {
    update: (state) => {
      //
      state.value = !state.value;
    },
  },
});

// Action creators are generated for each case reducer function
export const { update } = emisoresSlices.actions;

export default emisoresSlices.reducer;
